import { Dispatch } from "redux";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { getServiceTemplatesRequest } from "@requests/management-console/get-service-templates";
import {
    setServiceTemplates,
    setServiceTemplatesLoading,
} from "@redux/actions/service-templates-actions";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { formatServiceTemplates } from "@formatters/service-templates/service-template-formatter";
import { FormattedRpServiceTemplate } from "@idw-types/data/reference-data/generic";

export const getServiceTemplatesReduxRequest = (
    dispatch: Dispatch
) => async (axnCompanies: Array<AxnCompany>): Promise<Array<FormattedRpServiceTemplate>> => {
    dispatch(setServiceTemplatesLoading(true));

    const { data, error } = await getServiceTemplatesRequest();

    if (data?.rpServiceTemplates) {
        const formattedServiceTemplates = formatServiceTemplates(data.rpServiceTemplates, axnCompanies);
        dispatch(setServiceTemplates(formattedServiceTemplates));
        return formattedServiceTemplates;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getServiceTemplates.error.title,
                resources.requests.getServiceTemplates.error.message
            );
        }

        dispatch(setServiceTemplatesLoading(false));
        return null;
    }
};
